import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    padding: 1rem;
    opacity: ${props => props.isOpen ? 1 : 0};
    visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
    transition: all 0.3s ease;
`;

export const ModalContainer = styled.div`
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 25px;
    max-width: 800px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.9)'};
    transition: transform 0.3s ease;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);

    @media (max-width: 768px) {
        max-height: 95vh;
        border-radius: 20px;
    }
`;

export const ModalCloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.8rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
    line-height: 1;

    &:hover {
        background: rgba(255, 107, 139, 0.4);
        border-color: rgba(255, 107, 139, 0.6);
        transform: rotate(90deg) scale(1.1);
    }

    @media (max-width: 480px) {
        width: 40px;
        height: 40px;
        font-size: 1.5rem;
    }
`;

export const GalleryContainer = styled.div`
    position: relative;
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 25px 25px 0 0;

    @media (max-width: 768px) {
        height: 300px;
    }

    @media (max-width: 480px) {
        height: 250px;
        border-radius: 20px 20px 0 0;
    }
`;

export const MainImageContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    cursor: ${props => props.$isZoomable ? 'zoom-in' : 'default'};

    &:hover {
        ${props => props.$isZoomable && `
            & > img {
                transform: scale(1.02);
            }
        `}
    }
`;

export const MainImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
`;

export const ZoomIndicator = styled.div`
    position: absolute;
    bottom: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
    transition: all 0.2s ease;
    pointer-events: none;

    svg {
        display: block;
    }

    ${MainImageContainer}:hover & {
        transform: scale(1.1);
        background: rgba(107, 91, 255, 0.8);
    }

    @media (max-width: 480px) {
        bottom: 10px;
        right: 10px;
        padding: 8px;

        svg {
            width: 16px;
            height: 16px;
        }
    }
`;

export const NavigationButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${props => props.direction === 'left' ? 'left: 15px;' : 'right: 15px;'}
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 5;

    &:hover {
        background: rgba(107, 91, 255, 0.7);
        transform: translateY(-50%) scale(1.1);
    }

    @media (max-width: 480px) {
        width: 40px;
        height: 40px;
        font-size: 1.5rem;
    }
`;

export const ImageCounter = styled.span`
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 500;
`;

export const ThumbnailsContainer = styled.div`
    display: flex;
    gap: 0.75rem;
    padding: 1rem;
    overflow-x: auto;
    justify-content: center;
    background: rgba(0, 0, 0, 0.2);

    &::-webkit-scrollbar {
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.3);
        border-radius: 3px;
    }
`;

export const Thumbnail = styled.img`
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 3px solid ${props => props.isActive ? '#6b5bff' : 'transparent'};
    opacity: ${props => props.isActive ? 1 : 0.6};

    &:hover {
        opacity: 1;
        border-color: rgba(255, 255, 255, 0.5);
    }

    @media (max-width: 480px) {
        width: 55px;
        height: 55px;
    }
`;

export const ProductDetails = styled.div`
    padding: 1.5rem 2rem 2rem;

    @media (max-width: 480px) {
        padding: 1rem 1.5rem 1.5rem;
    }
`;

export const ProductTitle = styled.h2`
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 0.5rem 0;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 480px) {
        font-size: 1.5rem;
    }
`;

export const ProductPrice = styled.span`
    display: block;
    font-size: 1.6rem;
    font-weight: 700;
    color: #4ecdc4;
    margin-bottom: 1rem;

    @media (max-width: 480px) {
        font-size: 1.4rem;
    }
`;

export const ProductDescription = styled.p`
    font-size: 1.05rem;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
    margin: 0 0 1.5rem 0;

    @media (max-width: 480px) {
        font-size: 1rem;
    }
`;

// Helper para obtener gradiente del boton segun status
const getButtonBackground = (status) => {
    switch (status) {
        case 'sold':
            return 'linear-gradient(135deg, #555, #333)';
        case 'reserved':
            return 'linear-gradient(135deg, #888, #666)';
        default:
            return 'linear-gradient(135deg, #ff6b8b, #6b5bff)';
    }
};

export const ReserveButton = styled.button`
    background: ${props => getButtonBackground(props.$status)};
    color: white;
    padding: 1rem 2rem;
    border: none;
    border-radius: 15px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: ${props => props.$status === 'available' ? 'pointer' : 'not-allowed'};
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    width: 100%;

    &:hover {
        transform: ${props => props.$status === 'available' ? 'translateY(-3px)' : 'none'};
        box-shadow: ${props => props.$status === 'available' ? '0 15px 35px rgba(107, 91, 255, 0.4)' : 'none'};
    }

    &:disabled {
        cursor: not-allowed;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s;
        display: ${props => props.$status === 'available' ? 'block' : 'none'};
    }

    &:hover::before {
        left: ${props => props.$status === 'available' ? '100%' : '-100%'};
    }
`;
